// extracted by css-extract-rspack-plugin
export default {"editor":"bD4aN","editorContent":"aki0M","editorContentInner":"E5EKW","img":"uWdYT"};